import React, {useCallback} from 'react';
import {getSampleIdsFromSequence} from "utils/getSamplesFromSequence.js"
import {getSamples} from "utils/getSamplesForMint.js"
import {setIsPreparingNFT, setHicDialog} from 'actions/index.js';

export const useMintToHic = ({zobject, setDropdownPos}) => {
    const mintToHic = useCallback(async (e) => {
        e.stopPropagation();
        setDropdownPos(undefined);

        let sequencerEngine = zobject.sequencerEngine;
        sequencerEngine.dispatch(setIsPreparingNFT(true));
        let ipfsHash = await sequencerEngine.save("export", "PUBLIC", false, undefined, zobject);
        let sampleHashes = getSamples(sequencerEngine);
        let json = {
            projectId: ipfsHash,
            ipfsHashes: [ipfsHash, ... sampleHashes]
        };

        fetch('/exportZip/' , {
            method: 'POST',
            body: JSON.stringify(json),
            
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                sequencerEngine.dispatch(setIsPreparingNFT(false));
                sequencerEngine.dispatch(
                    setHicDialog(resp));
            })
            .catch(err => {
                console.log(err);
            });
    }, [zobject, setDropdownPos]);

    return {mintToHic};
};

